import { request, errHandler } from "./heimdall";
import store from "../store";

export function getUsers() {
  return request
    .get("/users", {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getUser(id) {
  return request
    .get(`/users/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function createUser(data) {
  return request
    .post("/users/create", data, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function updateUser(id, data) {
  return request
    .put(`/users/update/${id}`, data, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function updatePassword(id, data) {
  return request
    .put(`/users/updatePassword/${id}`, data, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function deleteUser(id) {
  return request
    .delete(`/users/delete/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}
